/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Payment_Edit_TitleInputs */

const de_billing_payment_edit_title = /** @type {(inputs: Billing_Payment_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlungsmethode ändern`)
};

/** @type {(inputs: Billing_Payment_Edit_TitleInputs) => LocalizedString} */
const en_billing_payment_edit_title = de_billing_payment_edit_title;

/**

* @param {Billing_Payment_Edit_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_payment_edit_title = /** @type {((inputs?: Billing_Payment_Edit_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Payment_Edit_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_billing_payment_edit_title(inputs)
	return en_billing_payment_edit_title(inputs)
});